import styled from "styled-components";

export const Wrapper = styled.div`
  margin-bottom: 96px;
`;

export const Title = styled.p`
  font-weight: 500;
  font-size: 21px;
  color: #565566;
  margin-left: 36px;
`;

export const ActivtyCardList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
